/**
 * Unique Diamonds — inline gallery video playback
 * ----------------------------------------------------------------------------
 * Videos in the PDP gallery are rendered with autoplay/muted/loop so they play
 * without a click. This keeps that state in sync with the Slick slider: only the
 * video on the active slide plays, the rest stay paused so we don't decode or
 * download video the shopper isn't looking at.
 *
 * Dawn's window.pauseAllMedia() (fired when any modal opens or closes) stops
 * every video on the page, so playback is re-applied afterwards.
 */
(function () {
  'use strict';

  var SLIDER = '.product-media--main-images-slider';
  var VIDEO = '.product-media--autoplay-video video';

  function play(video) {
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        /* Autoplay can still be refused (e.g. data saver) — poster stays visible. */
      });
    }
  }

  function syncSlider(slider) {
    var videos = slider.querySelectorAll(VIDEO);
    if (!videos.length) return;

    var active = slider.querySelector('.slick-current');

    Array.prototype.forEach.call(videos, function (video) {
      var isActive = !active || active.contains(video);
      if (isActive) {
        play(video);
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  function syncAll() {
    Array.prototype.forEach.call(document.querySelectorAll(SLIDER), syncSlider);
  }

  if (window.jQuery) {
    jQuery(document).on('init afterChange setPosition', SLIDER, function () {
      syncSlider(this);
    });
  }

  document.addEventListener('DOMContentLoaded', syncAll);
  document.body.addEventListener('modalClosed', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
})();
